"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterAttributeItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const attributes_filter_popover_styles_1 = require("./attributes-filter-popover.styles");
const hooks_1 = require("../../../hooks");
const hooks_2 = require("../attribute-list/strategy-attribute-item/hooks");
const generic_1 = require("../../../generic");
const models_1 = require("../../../models");
const FilterAttributeItem = ({ attribute, isChecked, isIndeterminate, isExpanded, valueSearch, isValueChecked, onToggleAttribute, onToggleExpand, onToggleValue, }) => {
    const { data: values, isLoading, pagination: { isLoadingMore, onNextPage, hasNextPage, }, } = (0, hooks_2.useAttributeValues)({
        attributeName: attribute.label,
        sortingItem: models_1.SortingItem.SortByTextAsc,
        isMeasure: attribute.isMeasure,
        valueSearch,
        options: { skip: !isExpanded },
    });
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading: isLoadingMore,
        hasNextPage,
        onLoadMore: onNextPage,
    });
    const handleParentToggle = (0, react_1.useCallback)((_e, checked) => {
        onToggleAttribute(attribute.label, checked);
    }, [attribute.label, onToggleAttribute]);
    const lastValueIndex = values.length - 1;
    return (react_1.default.createElement("li", null, react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterUl, null, react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterListSubheader, { disableSticky: false }, react_1.default.createElement("div", { className: "subheader-content" }, react_1.default.createElement(material_1.IconButton, { size: "small", onClick: () => onToggleExpand(attribute.label), "aria-label": "toggle expand" }, react_1.default.createElement(ui_components_1.Icon, { variant: isExpanded ? 'chevronUp' : 'chevronDown' })), react_1.default.createElement(material_1.FormControlLabel, { label: `${attribute.label} (${attribute.productCount})`, control: react_1.default.createElement(material_1.Checkbox, { checked: isChecked, indeterminate: isIndeterminate, onChange: handleParentToggle }) }))), isExpanded && isLoading && (react_1.default.createElement(material_1.ListItem, { sx: { justifyContent: 'center' } }, react_1.default.createElement(generic_1.LoadingIndicator, null))), isExpanded && !isLoading && values.map((val, index) => (react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterChildListItem, { key: val.value, ref: index === lastValueIndex ? lastElementRef : undefined }, react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { checked: isValueChecked(attribute.label, val.value), onChange: (_evt, checked) => onToggleValue(attribute.label, val.value, checked) }), label: react_1.default.createElement(material_1.Tooltip, { title: `${val.value} (${val.productCount})`, placement: "right" }, react_1.default.createElement("div", null, react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterListItemText, { primary: `${val.value} (${val.productCount})` }))) })))), isExpanded && isLoadingMore && (react_1.default.createElement(material_1.ListItem, { sx: { justifyContent: 'center' } }, react_1.default.createElement(generic_1.LoadingIndicator, null))))));
};
exports.FilterAttributeItem = FilterAttributeItem;
